import React, { useEffect, useMemo, useState } from "react";
import Config from "../../config/Config";
import { useAppSelector } from "../../core/feature/hooks";
import User from "../../core/models/user";
import TabsMobile from "../__template/TabsMobileComponent";
import users from "../../assets/images/icon_profile/user.svg";
import { t } from "i18next";

const ComponentAutoLogin = () => {
  const user: User = useAppSelector((state) => state.user.user);
  const [autoLogin, setAutoLogin] = useState("true");
  const env = Config.BaseUrlDev;
  const getProfileImage = useMemo(() => {
    if (user?.photoUrl == "") {
      return users;
    }
    return env + "main_a/image/get/" + user?.photoUrl + "/pas";
  }, [user]);

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    console.log(event.target.value);

    // if (event.target.value == "true") return setAutoLogin("true");
    // return setAutoLogin("false");
  };

  useEffect(() => {
    console.log(autoLogin);
  }, [autoLogin]);
  return (
    <div className="min-h-screen h-full  bg-psp-primary">
      <div className={`px-8 pt-8 pb-3  sticky top-0 z-50 transparent`}>
        <TabsMobile
          name={`${t("AUTO-LOGIN.title")}`}
          backUrl={"profile"}
        ></TabsMobile>
      </div>

      <section className="p-4 pt-0 top-to-bottom">
        <div className="flex mt-4 flex-col">
          <h1 className="text-sm font-medium font-montserrat">
            {t("AUTO-LOGIN.subtitle")}
          </h1>
          <div className="flex flex-col gap-2">
            <div className="flex flex-row gap-2">
              <input
                type="radio"
                name="autoLogin"
                value="true"
                id="true"
                defaultChecked
                onChange={(e) => setAutoLogin(e.target.value)}
              />
              <label htmlFor="true" className="font-montserrat text-sm">
                {t("OTHER.yes")}
              </label>
            </div>
            <div className="flex flex-row gap-2">
              <input
                type="radio"
                name="autoLogin"
                value="false"
                id="false"
                onChange={(e) => setAutoLogin(e.target.value)}
              />
              <label htmlFor="false" className="font-montserrat text-sm">
                {t("OTHER.no")}
              </label>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ComponentAutoLogin;
